var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClipIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.879 8.375L8.393 13.861C7.567 14.687 7.567 16.027 8.393 16.853V16.853C9.219 17.679 10.559 17.679 11.385 16.853L18.617 9.621C20.132 8.106 20.132 5.65 18.617 4.135V4.135C17.102 2.62 14.646 2.62 13.131 4.135L5.899 11.367C3.695 13.571 3.695 17.143 5.899 19.347V19.347C8.103 21.551 11.675 21.551 13.879 19.347L18.268 14.958",
    stroke: "#1CA8E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClipIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ClipIcon.5aba1384.svg";
export { ForwardRef as ReactComponent };